import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {Package} from "../../../model/package";
import {PropertyFormComponent} from "../property-form/property-form.component";
import {ActivatedRoute, Router} from "@angular/router";
import {ProductsContainerComponent} from "../products-container/products-container.component";
import {PropertyForm} from "../../../model/propertyForm";
import {Property} from "../../../model/property";
import * as $ from 'jquery';
import {DropzoneComponent} from "../../dropzone/dropzone.component";
import {Document} from "../../../model/document";

@Component({
  selector: 'app-new-order-mobile',
  templateUrl: './new-order-mobile.component.html'
})
export class NewOrderMobileComponent implements OnInit, AfterViewInit {


  property: Property;
  packages: Array<Package>;
  @ViewChild(PropertyFormComponent) propertyFormComponent: PropertyFormComponent;
  @ViewChild(ProductsContainerComponent) productsContainerComponent: ProductsContainerComponent;
  @ViewChild(DropzoneComponent) dropzoneComponent: DropzoneComponent;
  extraDocuments: boolean = false;
  displayNachweisDrop: boolean = false;
  legitimateInterest: string = "init";
  files: Array<any>;
  documents: Array<Document>;
  toNextPage: boolean = false;
  errorMsg: string;
  legitimateInterestUrl: string = "/api/legitimateInterest";


  constructor(private router: Router, private route: ActivatedRoute) {

    let legitimateInterest = JSON.parse(sessionStorage.getItem("legitimate_interest"));
    this.legitimateInterest = legitimateInterest ? legitimateInterest : this.legitimateInterest;
  }

  displayNachweis() {
    let value = $("#legitimateInterest option").filter(":selected").val();
    if (value !== "owner")
      this.displayNachweisDrop = true;
  }

  ngOnInit(): void {

    this.property = JSON.parse(sessionStorage.getItem("new_order_property"));

    if (!this.property)
      this.property = new Property();

    let documentNames = this.property.documents.map(item => {
      return item;
    });

    this.packages = [
      {
        name: "Einzeldokument",
        logo: "",
        price: 29.95,
        priceUnit: "Dokument",
        text: "individuel & flexibel zusammenstellen",
        documents: [],
        additionalDocuments: true,
        selected: false,
        moreInfos: "Keines der Pakete passt zu Ihrem Bedarf? Dann stellen Sie sich die benötigten Auskünfte individuell zusammen."
      },
      {
        name: "Finanzierungspaket",
        logo: "",
        price: 69.95,
        priceUnit: "Paket",
        text: "",
        documents: ["liegen", "baulas", "altlas"],
        additionalDocuments: false,
        selected: this.compareLists(["liegen", "baulas", "altlas"], documentNames),
        moreInfos: "Mit der Wahl des Finanzierung-Paket erlangen Sie einen Preisvorteil in Höhe von mehr als 50% gegenüber Einzelauskünften. Das <b>Finanzierung-Paket</b> besteht aus der Liegenschaftskarte, Baulastenauskunft und Altlastenauskunft. Zum Nachweis des berechtigten Interesses bei den Behörden ist ein Grundbuchauszug im Paket enthalten. Das Paket eignet sich ideal für Immobilienvorhaben mit einem Volumen bis zu 500.000 Euro. Sollten Sie Fremdkapital für die Maßnahme aufnehmen, wird die finanzierende Bank diese Auskünfte von Ihnen fordern."
      },
      {

        name:"Hauskaufpaket",
        logo: "",
        price: 89.95,
        priceUnit: "Paket",
        text: "",
        documents: ["liegen", "baulas", "altlas", "erschl", "bodendenkma"],
        additionalDocuments: false,
        selected: this.compareLists(["liegen", "baulas", "altlas", "erschl"], documentNames),
        moreInfos: "Mit der Wahl des Hauskauf-Paket profitieren Sie von einem Preisvorteil in Höhe von 56% gegenüber Einzelauskünften. Das <b>Hauskauf-Paket</b> beinhaltet die Auskünfte des Starter-Pakets inklusive einer Erschließungsbeitragsbescheinigung und einer Bodendenkmalschutzauskunft, die Ihnen weitere Informationen für die Risikoprüfung liefern. Zum Nachweis des berechtigten Interesses bei den Behörden ist ein Grundbuchauszug im Paket enthalten."
      },
      {
        name: "Hausbaupaket",
        logo: "",
        price: 129.95,
        priceUnit: "Paket",
        text: "",
        documents: ["liegen", "baulas", "altlas", "erschl", "bodendenkma", "gedenkma", "fläche", "bebauu"],
        additionalDocuments: false,

        selected: this.compareLists(["liegen", "baulas", "altlas", "erschl", "bodendenkma", "gedenkma", "teilun"], documentNames),
        moreInfos: "Mit der Wahl des Hausbau-Paket profitieren Sie von einem Preisvorteil in Höhe von 58% gegenüber" +
          " Einzelauskünften. Das Hausbau-Paket beinhaltet die Auskünfte des Standard-Pakets inklusive einer " +
          "Gebäudedenkmalschutzauskunft und einer Teilungserklärung. Zum Nachweis des berechtigten Interesses bei den" +
          " Behörden ist ein Grundbuchauszug im Paket enthalten."

      }];
  }

  ngAfterViewInit(): void {
    this.property = JSON.parse(sessionStorage.getItem("new_order_property"));
    if (this.property) {
      this.productsContainerComponent.documents = this.property.documents;
      this.property.documents = null;
      this.propertyFormComponent.propertyForm.patchValue(new PropertyForm(this.property));
    }
  }

  selectPackage(event) {
    let that = this;

    this.packages.forEach(function (p) {
        if (p.name === event) {
          that.extraDocuments = p.additionalDocuments;
          that.setDocuments(p.documents);
        }
      }
    )
  }

  setDocuments(documents) {
    let documentObjects = []
    documents.forEach(function (document) {
      documentObjects.push(new Document(document));
    })
    this.productsContainerComponent.documents = documentObjects;
  }

  addAuthority() {
    this.toNextPage = true;
    let propertyForm = this.propertyFormComponent.propertyForm;
    let value = $("#legitimateInterest option").filter(":selected").val();
    if (!propertyForm.valid) {
      this.errorMsg = "Bitte geben Sie alle relevanten Objektdaten an."
    } else if (this.productsContainerComponent.documents.length <= 0) {
      this.errorMsg = "Bitte wählen Sie ein Paket aus."
    }else if(!value){
      this.errorMsg = "Bitte wählen Sie Ihr Berechtigtes Interesse."
    } else if (value !== "owner" && this.dropzoneComponent.files.length <= 0) {
      this.errorMsg = "Bitte laden Sie ein Nachweis hoch."
      this.displayNachweisDrop = true;
    } else {
      this.errorMsg = null;
      this.storeInSession();
      this.router.navigate(['/authority']);
    }

    console.log(this.errorMsg);

  }


  @HostListener('window:beforeunload', ['$event'])
  storeInSession() {
    let propertyForm = this.propertyFormComponent.propertyForm;
    this.property = propertyForm.value;
    this.property.documents = this.productsContainerComponent.documents;
    sessionStorage.setItem("new_order_property", JSON.stringify(this.property));
    sessionStorage.setItem("legitimate_interest", JSON.stringify(this.legitimateInterest));


  }

  compareLists(listA, listB) {
    if (listA.length != listB.length)
      return false;

    listA.forEach(function (elem) {
        if (!listB.includes(elem))
          return false;
      }
    )

    return true;
  }

}
